import React from 'react';
import styled, { keyframes, css } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const SkeletonBase = styled.div<{ $width?: string; $height?: string; $borderRadius?: string }>`
  width: ${props => props.$width || '100%'};
  height: ${props => props.$height || '16px'};
  background: linear-gradient(
    90deg,
    ${props => props.theme.colors.gray?.[200] || '#e5e7eb'} 0%,
    ${props => props.theme.colors.gray?.[100] || '#f3f4f6'} 50%,
    ${props => props.theme.colors.gray?.[200] || '#e5e7eb'} 100%
  );
  background-size: 2000px 100%;
  ${css`animation: ${shimmer} 2s infinite;`}
  border-radius: ${props => props.$borderRadius || props.theme.borderRadius.sm};
`;

export const SkeletonBox = styled(SkeletonBase)``;

export const SkeletonCircle = styled(SkeletonBase)`
  border-radius: 50%;
  aspect-ratio: 1;
`;

export const SkeletonLine = styled(SkeletonBase)``;

export const SkeletonImage = styled(SkeletonBase)`
  aspect-ratio: 1;
  border-radius: ${props => props.theme.borderRadius.md};
`;

interface BaseSkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
}

export const Skeleton: React.FC<BaseSkeletonProps & { $width?: string; $height?: string; $borderRadius?: string }> = ({ width, height, borderRadius, $width, $height, $borderRadius }) => {
  return <SkeletonBase $width={$width || width} $height={$height || height} $borderRadius={$borderRadius || borderRadius} />;
};
